module.exports = __webpack_public_path__ + "static/2-bjarki-2f3a98236ab29ea75e9921009314a947.jpg";